import { api } from '../http';

export const fetchAuctionWatch = auctionId => api.get(`/auctions/${auctionId}/watch`);
export const updateAuctionWatch = auctionId => api.patch(`/auctions/${auctionId}/watch`);
